import { useRouter } from '../router';
import { locationDescriptorRemovingBasePath } from './utils';
export const Redirect = _ref => {
  let {
    to
  } = _ref;
  const router = useRouter();
  router.push(locationDescriptorRemovingBasePath(to, router.basePath));
  return null;
};